import React from 'react';
import BlockContainer from './BlockContainer';
import OptionContainer from './OptionContainer';
import styles from './PageThree.module.scss';
import TitleContainer from './TitleContainer';

export default function PageThree() {

    return (
        <div className={styles["container"]} id="pageThree">
            <BlockContainer />
            <div className={styles["main-container"]}>
                <TitleContainer file={"./assets/page_3/3_title.png"} />
                <div className={styles["option-container"]}>
                    <OptionContainer />
                </div>
            </div>
        </div>
    )
}